import { createApiClient } from "../apiService";
import { SuccesType } from "../review/reviewTypes";
import { affiliationSchema, createAffiliationTypes } from "./affiliationTypes";
import { useToken } from "../tokenUtils";


const apiClient = createApiClient('');


export const handleGetRequest = async <T>(apiClient: any, path: string, token?: string): Promise<T> => {
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
  };

  try {
    const response = await apiClient.get(path, { headers });
    return response.data;
  } catch (error: any) {
    console.error('Error en handleGetRequest:', error.response?.data || error.message);
    throw error;
  }
};

const handleRequest = async (path: string, data: any, token?: string): Promise<any> => {
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
  };

  const res = await apiClient.post(path, data, { headers });
  return res.data;
};

const handlePatchRequest = async (url: string, data: any, token?: string): Promise<any> => {
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
  };

  const res = await apiClient.patch(url, data, { headers });
  return res.data;
};

const createAffiliations = async (data: createAffiliationTypes): Promise<SuccesType> => {
  const currentToken = useToken();
  if (!currentToken) {
    throw new Error("Authentication token not found.");
  }

  try {
    affiliationSchema.parse(data);
  } catch (validationError) {
    console.error('Error en la validación de los datos:', validationError);
    throw validationError;
  }
  
  const res = await handleRequest('/affiliation', data, currentToken);
  return res.data;
};

const editAfilliation = async (data: createAffiliationTypes): Promise<SuccesType> => {
  const currentToken = useToken();
  if (!currentToken) {
    throw new Error("Authentication token not found.");
  }
  
  const res = await handlePatchRequest(`/affiliation/${data.slug}`, data, currentToken);
  return res.data;
};

const affiliationService = {
  createAffiliations,
  editAfilliation,
};

export default affiliationService;